import React from "react";

export const ClientsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
     
    >
      <path d="M7 4a3 3 0 00-1.747 5.439c.414.298.747.802.747 1.42 0 .734-.464 1.306-1.016 1.57-1.022.486-1.589 1.402-1.838 2.76a.587.587 0 00.169.532A.956.956 0 004 16h12c.282 0 .53-.117.685-.28a.587.587 0 00.17-.53c-.25-1.358-.817-2.275-1.839-2.762-.552-.263-1.016-.835-1.016-1.57 0-.617.333-1.121.747-1.419A3 3 0 0013 4h-.5a1 1 0 110-2h.5a5 5 0 013.236 8.811c1.545.89 2.287 2.391 2.585 4.017C19.16 16.666 17.582 18 16 18H4c-1.582 0-3.159-1.334-2.821-3.172.299-1.626 1.04-3.128 2.585-4.017a5 5 0 116.479-.005c.698.377 1.41.902 1.984 1.506C12.88 13 13.5 13.941 13.5 15h-2c0-.295-.2-.761-.722-1.31a6.09 6.09 0 00-1.754-1.259C8.457 12.167 8 11.587 8 10.86c0-.618.333-1.122.747-1.42A3 3 0 007 4z"></path>
    </svg>
  );
};